<template>
  <!-- 列表页 -->
  <div class="product-list main">
    <div class="crumbs">
      <span>全部结果</span>
      <span> > </span>
      <span>{{ category }}</span>
    </div>
    <!-- 品牌数据 -->
    <!-- <div class="brand">
      <div class="label">所有品牌：</div>
      <div class="brand-list">
        <ul>
          <li
            v-for="index in 16"
            :key="index"
            :class="index === i ? 'active': ''"
            @click="i = index"
          >艾迪大厦</li>
        </ul>
      </div>
    </div>-->
    <!-- 筛选 -->
    <div class="screen">
      <ul>
        <!-- <li :class="screenIndex === 1 ? 'screen-active' : ''" @click="screenIndex = 1">综合</li>
        <li :class="screenIndex === 2 ? 'screen-active' : ''" @click="screenIndex = 2">优惠</li>
        <li :class="screenIndex === 3 ? 'screen-active' : ''" @click="screenIndex = 3">销量</li>
        <li :class="screenIndex === 4 ? 'screen-active' : ''" @click="screenIndex = 4">新品</li>
        <li :class="screenIndex === 5 ? 'screen-active' : ''" @click="screenIndex = 5">价格</li>
        <li>
          <input class="li-input" />
        </li>
        <li>-</li>
        <li>
          <input class="li-input" />
        </li> -->
      </ul>
      <div class="product-num">
        <span>共{{ total }}件商品</span>
        <!-- <span>第1页/共20页</span> -->
      </div>
    </div>
    <!-- 只看有货 -->
    <!-- <div class="look-goods">只看有货</div> -->
    <a-empty v-if="total === 0" class="mt20" description="暂不能查看该类商品" />
    <!-- 商品列表 -->
    <div v-else class="product-content">
      <product-box
        v-for="(product, index) in productListResult"
        :key="index"
        :productObj="product"
        @goDetail="goDetail(product)"
      ></product-box>
    </div>
    <!-- <div style="text-align: right;">
      <a-pagination v-model="current" :total="total" :defaultPageSize="10" @change="pageChange" />
    </div> -->
  </div>
</template>
<script>
import productBox from '@/components/productBox.vue'
import { shopSkus } from '@/serve/shop'
import { getCategoryDetail } from '@/serve/category'
// import { getBrands } from '@/serve/brands'
import { mapGetters } from 'vuex'
export default {
  name: 'productList',
  components: {
    productBox
  },
  data () {
    return {
      i: -1,
      current: 1,
      screenIndex: 1,
      productListResult: [],
      params: {
        page: 0,
        rows: 25,
        shoperType: sessionStorage.getItem('loginType') || 'STUDENT',
        ageStage: sessionStorage.getItem('ageStage') || '',
        blocTagBlocId: sessionStorage.getItem('blocTagBlocId') || ''
      },
      total: 0,
      keyword: '', // 关键字
      id: 1,
      category: '', // 分类信息
      ageStage: '', // 年龄层次
      blocTagBlocId: '' // 商品售卖目标id(卖给哪个园)
    }
  },
  computed: {
    ...mapGetters(['keyWord'])
  },
  watch: {
    '$route.params.id' (newVal, oldVal) {
      if (newVal) {
        this.id = newVal
        this.params.categoryId = this.id
        // this.init()
        this.getCategory()
        this.getProducts()
      }
    },
    '$route.query.ageStage' (newVal, oldVal) {
      if (newVal) {
        this.params.blocTagBlocId = ''
        this.params.ageStage = newVal
        this.ageStage = newVal
        this.getProducts()
      } /* else if (!newVal) {
        this.params.blocTagBlocId = this.blocTagBlocId
        this.params.ageStage = ''
        this.getProducts()
      } */
    },
    '$route.query.value' (newVal, oldVal) {
      if (newVal) {
        this.params.ageStage = ''
        this.blocTagBlocId = newVal
        this.params.blocTagBlocId = this.blocTagBlocId
        // this.init()
        this.getProducts()
      }
    },
    keyWord (newVal, oldVal) {
      this.params.keyword = newVal
      this.getProducts()
    }
  },
  methods: {
    goDetail (val) {
      this.$router.push({ path: '/product/' + val.sku })
    },
    // 分页
    pageChange (page) {
      this.params.page = page - 1
      this.getProducts()
    },
    // 获取商品
    getProducts () {
      this.productListResult = []
      let tempName = []
      shopSkus(this.params).then(res => {
        // this.productListResult = res.products
        res.products.forEach(item => {
          if (tempName.indexOf(item.productId) === -1) {
            tempName.push(item.productId)
            this.productListResult.push(item)
          }
        })
        this.total = this.productListResult.length
      })
    },
    // 获取品牌信息
    // getBrands () {
    //   getBrands().then(res => {
    //     console.log('品牌', res)
    //   }
    //   )
    // },
    // 获取分类信息
    getCategory () {
      getCategoryDetail(this.id).then(res => {
        if (res.parentCategory) {
          this.category = res.parentCategory.name + ' > ' + res.name
        } else {
          this.category = res.name
        }
      })
    }
  },
  created () {
    this.id = this.$route.params.id
    this.keyword = this.$route.query.keyWord
    this.ageStage = this.$route.query.ageStage
    this.blocTagBlocId = this.$route.query.value
    if (this.id) {
      this.params.categoryId = this.id
      this.getCategory()
      this.getProducts()
    } else if (this.keyword) {
      this.params.keyword = this.keyword
      this.getProducts()
    } else if (this.ageStage) {
      this.params.ageStage = this.ageStage
      this.getProducts()
    } else if (this.blocTagBlocId) {
      this.params.blocTagBlocId = this.blocTagBlocId
      this.getProducts()
    }
    // this.getBrands()
  }
}
</script>
<style lang="less" scoped>
.product-list {
  
  .crumbs {
    padding: 0 20px;
    font-size: 14px;
    line-height: 50px;
    border-bottom: 1px solid #ccc;
  }
  // 品牌
  .brand {
    padding: 20px;
    display: flex;
    border-bottom: 1px solid #ccc;
    .label {
      width: 100px;
    }
    .brand-list {
      width: 1090px;
      ul {
        padding-left: 0;
        li {
          width: 100px;
          display: inline-block;
          padding: 10px 0;
          cursor: pointer;
          text-align: center;
          border: 1px solid #ccc;
          &:hover {
            background: rgb(241, 240, 240);
          }
        }
        .active {
          background: rgb(241, 240, 240);
        }
      }
    }
  }
  // 筛选
  .screen {
    line-height: 40px;
    background: #f2f2f2;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    ul {
      margin: 0;
      padding: 0;
      li {
        display: inline-block;
        margin-right: 20px;
        cursor: pointer;
        &:hover {
          color: #e69b47;
        }

        .li-input {
          width: 70px;
          height: 28px;
        }
      }
      .screen-active {
        color: #e69b47;
      }
    }
    .product-num {
      span {
        margin-right: 10px;
        color: #999;
      }
    }
  }
  // 只看有货
  .look-goods {
    padding-left: 20px;
    line-height: 40px;
    border-bottom: 1px solid #e6e6e6;
  }

  .product-content {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    // flex-wrap: wrap;
    // justify-content: space-between;
    .product-box {
      margin: 10px 28px 10px 0;
      &:nth-child(5n) {
        margin-right: 0;
      }
    }
  }
}
</style>
